import axios from 'axios';

function setJwt(jwt) {
    if(jwt){
        axios.defaults.headers.common['Authorization'] = "Bearer " + jwt;
    }
}

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    responseInterceptor: axios.interceptors.response,
    setJwt
}